import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Collections from "./pages/Collections";
import CollectionDetail from "./pages/CollectionDetail";
import Generate from "./pages/Generate";
import AllImages from "./pages/AllImages";
import Settings from "./pages/Settings";
import Bank from "./pages/Bank";
import VaultDetail from "./pages/VaultDetail";
import KnockoutPage from "./pages/KnockoutPage";
import RetailOutlets from "./pages/RetailOutlets";
import RadStore from "./pages/RadStore";
import NoveltyStore from "./pages/NoveltyStore";
import BadManorzStore from "./pages/BadManorzStore";
import PopBoutique from "./pages/PopBoutique";
import PopWaitlist from "./pages/PopWaitlist";
import Layout from "./components/Layout";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-8 h-8 border-2 border-black border-t-transparent rounded-full spinner mx-auto"></div>
  </div>
);

function ProtectedRoute({ children, fullAccessOnly = false, allowedRoles = null }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (fullAccessOnly && user.role === 'pop_boutique') return <Navigate to="/pop-boutique" replace />;
  if (fullAccessOnly && user.role === 'pop_waitlist') return <Navigate to="/pop-waitlist" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (user) return <Navigate to={user.role === 'pop_boutique' ? '/pop-boutique' : user.role === 'pop_waitlist' ? '/pop-waitlist' : '/'} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<ProtectedRoute fullAccessOnly><Dashboard /></ProtectedRoute>} />
            <Route path="collections" element={<ProtectedRoute fullAccessOnly><Collections /></ProtectedRoute>} />
            <Route path="collections/:id" element={<ProtectedRoute fullAccessOnly><CollectionDetail /></ProtectedRoute>} />
            <Route path="generate" element={<ProtectedRoute fullAccessOnly><Generate /></ProtectedRoute>} />
            <Route path="images" element={<ProtectedRoute fullAccessOnly><AllImages /></ProtectedRoute>} />
            <Route path="bank" element={<ProtectedRoute fullAccessOnly><Bank /></ProtectedRoute>} />
            <Route path="bank/vaults/:id" element={<ProtectedRoute fullAccessOnly><VaultDetail /></ProtectedRoute>} />
            <Route path="knockout" element={<ProtectedRoute fullAccessOnly><KnockoutPage /></ProtectedRoute>} />
            <Route path="retail-outlets" element={<ProtectedRoute fullAccessOnly><RetailOutlets /></ProtectedRoute>} />
            <Route path="rad-store" element={<ProtectedRoute fullAccessOnly><RadStore /></ProtectedRoute>} />
            <Route path="novelty-store" element={<ProtectedRoute fullAccessOnly><NoveltyStore /></ProtectedRoute>} />
            <Route path="bad-manorz-store" element={<ProtectedRoute allowedRoles={['admin']}><BadManorzStore /></ProtectedRoute>} />
            <Route path="pop-boutique" element={<ProtectedRoute allowedRoles={['admin', 'pop_boutique']}><PopBoutique /></ProtectedRoute>} />
            <Route path="pop-waitlist" element={<ProtectedRoute allowedRoles={['admin', 'pop_boutique', 'pop_waitlist']}><PopWaitlist /></ProtectedRoute>} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
